import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-menos_aeb7e8ab9496f675599c9224bc72af69",
  "use": "ic-menos_aeb7e8ab9496f675599c9224bc72af69-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"ic-menos_aeb7e8ab9496f675599c9224bc72af69\">\n    <path fill=\"#222\" d=\"M5 11h14v2H5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id